import { FC, useRef } from "react";
import Logo from "shared/Logo/Logo";

import MenuBar from "shared/MenuBar/MenuBar";

interface Header3Props {
  className?: string;
}

const Header: FC<Header3Props> = ({ className = "" }) => {
  const headerInnerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div className={`nc-Header nc-Header-3 fixed z-40 top-0 inset-0 bg-black/30 dark:bg-black/50 transition-opacity will-change-[opacity] invisible opacity-0 pointer-events-none`}></div>
      <header ref={headerInnerRef} className={`sticky top-0 z-40 ${className}`}>
        <div className={`bg-white dark:bg-neutral-900 absolute h-full inset-x-0 top-0 transition-transform will-change-[transform,opacity]`}></div>
        <div className="relative px-4 lg:container h-[88px] flex">
          <div className="flex-1 flex items-center justify-between">
            {/* Logo (lg+) */}
            <div className="relative z-10  md:flex flex-1">
              <Logo />
            </div>

            {/* NAV */}
            <div className=" md:flex relative z-10 items-center justify-end text-neutral-700 dark:text-neutral-100">
              <div className="items-center flex space-x-1">
                <div className="md:block">
                  <MenuBar />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
